function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEverywhereBlueNoText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: 0,
    y: 0,
    width: "5.625rem",
    height: "5.5rem",
    viewBox: "0 0 90 88",
    style: {
      enableBackground: "new 0 0 90 88"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Component_7_1",
    transform: "translate(2.72)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_9",
    transform: "translate(32.028 61.785) rotate(-60)"
  }, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "none"
    },
    cx: 6.715,
    cy: 7.081,
    r: 6.215
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "none",
      stroke: "#0A85C7",
      strokeWidth: 3
    },
    cx: 6.715,
    cy: 7.081,
    r: 4.715
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    style: {
      fill: "#0A85C7"
    },
    d: "M41.21,33.862h0.708l0.708,20.304H40.41L41.21,33.862z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5-2",
    transform: "translate(53.067 32.762)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_7",
    transform: "translate(14.413 11.832)"
  }, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "none"
    },
    cx: 6.144,
    cy: 5.144,
    r: 5.144
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "none",
      stroke: "#0A85C7",
      strokeWidth: 3
    },
    cx: 6.144,
    cy: 5.144,
    r: 3.644
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    transform: "matrix(-0.985, 0.174, -0.174, -0.985, 17.321, 14.383)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3-2",
    style: {
      fill: "#0A85C7"
    },
    d: "M13.106,13.893l0.456-0.473L0.446-0.174l-1.43,1.479L13.106,13.893z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9",
    transform: "translate(46.437 38.971)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_8",
    style: {
      fill: "#0A85C7"
    },
    cx: 10.072,
    cy: 11.637,
    r: 4.217
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    transform: "translate(8.135 10.006) rotate(-166)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3-3",
    style: {
      fill: "#0A85C7"
    },
    d: "M6.794,7.319l0.532-0.683L0.758,0.242L-0.97,2.03L6.794,7.319z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_49"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_7-2",
    transform: "translate(2.693 43.788)"
  }, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "none"
    },
    cx: 6.144,
    cy: 5.144,
    r: 5.144
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "none",
      stroke: "#0A85C7",
      strokeWidth: 3
    },
    cx: 6.144,
    cy: 5.144,
    r: 3.644
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3-2",
    transform: "matrix(0.985, 0.174, -0.174, 0.985, 12.615, 32.065)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3-4",
    style: {
      fill: "#0A85C7"
    },
    d: "M15.075,0.36l0.457,0.473L2.414,14.427l-1.429-1.479L15.075,0.36z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_13",
    transform: "translate(20.003 38.973)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_8-2",
    style: {
      fill: "#0A85C7"
    },
    cx: 5.944,
    cy: 11.633,
    r: 4.217
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4-2",
    transform: "translate(3.895 2.028) rotate(-14)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3-5",
    style: {
      fill: "#0A85C7"
    },
    d: "M8.734,1.387L9.266,2.07L2.698,8.464L0.971,6.676L8.734,1.387z"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    style: {
      fill: "#0A85C7"
    },
    d: "M7.118,47.201c-1.203-2.277-1.867-4.883-1.82-7.641 c0.129-7.599,5.647-14.031,13.138-15.313c4.89-11.926,18.522-17.628,30.447-12.738c4.881,2.001,8.938,5.597,11.514,10.201 c1.85-0.668,3.802-1.009,5.768-1.007c9.646,0.146,17.347,8.083,17.199,17.729c-0.052,3.456-1.106,6.667-2.885,9.356l-2.326-0.978 c1.774-2.507,2.796-5.581,2.742-8.887c-0.131-8.083-6.651-14.602-14.733-14.734c-1.687-0.002-3.359,0.29-4.945,0.863l-1.92,0.693 l-1.019-1.793c-5.637-10.078-18.375-13.678-28.452-8.042c-4.124,2.307-7.345,5.941-9.138,10.313l-0.534,1.268l-1.341,0.211 c-7.25,1.244-12.118,8.13-10.874,15.38c0.289,1.685,0.887,3.251,1.731,4.644L7.118,47.201z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEverywhereBlueNoText);
export default __webpack_public_path__ + "static/media/everywhere-blue-no-text.175655c5d83b52e902f1794cec1d3ea5.svg";
export { ForwardRef as ReactComponent };